import StorageService from "../services/StorageService.js";
import { sanitizeRun } from "../services/syncMerge.js";
import { isoWeek } from "./WeekUtils.js";

/**
 * Meilleure partie de la semaine d'un mode (48 du TODO), pour le classement
 * hebdomadaire : `{gameId}.weekRun` = `{ week, score, errors, duration, recordedAt }`.
 * Une nouvelle semaine efface la précédente ; à semaine égale, seul un meilleur
 * run la remplace (même ordre que `bestRun` : score, puis fautes, puis temps).
 * Partagée entre langues et synchronisée, comme `bestRun`.
 */
export function isBetterRun(a, b) {
	if (a.score !== b.score) return a.score > b.score;
	const ea = a.errors ?? Infinity, eb = b.errors ?? Infinity;
	if (ea !== eb) return ea < eb;
	return (a.duration ?? Infinity) < (b.duration ?? Infinity);
}

export function saveWeekRun(gameId, run, now = Date.now()) {
	if (!run || typeof run.score !== "number" || run.score <= 0) return;
	const candidate = { ...sanitizeRun(run), week: isoWeek(now) };
	const existing = StorageService.load(`${gameId}.weekRun`);
	if (!existing || existing.week !== candidate.week || isBetterRun(candidate, sanitizeRun(existing))) {
		StorageService.save(`${gameId}.weekRun`, candidate);
	}
}
